import { http } from "./http.js";

async function getFactory(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updateFactory(resource, id, factory) {
  const response = await http.put(`/${resource}/${id}`, factory);
  return response;
}

async function createFactory(resource, factory) {
  const response = await http.post(`/${resource}`, factory);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

async function saveFactoryAttachments(resource, id, attachments) {
  const response = await http.post(
    `${resource}/${id}/attachments`,
    attachments,
  );
  return response;
}

async function getContactPersonReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function createContactPersonReference(
    factoryId,
    loadingPlaceId,
    responseId,
) {
  const response = await http.post(
    `factories/${factoryId}/loading-places/${loadingPlaceId}/contact-persons`,
    { value: responseId },
  );
  return response;
}

async function getFactoryContactPerson(factoryId, loadingPlaceId) {
  const response = await http.get(
    `factories/${factoryId}/loading-places/${loadingPlaceId}/contact-persons`,
  );
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function getFactoryReferencies(resource) {
  const response = await http.get(`${resource}/referencies`);
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

export {
  getFactory,
  updateFactory,
  createFactory,
  changeRemovedState,
  saveFactoryAttachments,
  getContactPersonReference,
  createContactPersonReference,
  getFactoryContactPerson,
  getFactoryReferencies,
};
